import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'default' | 'violet' | 'cyan' | 'emerald' | 'rose' | 'amber';

interface ChipProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

const TONE: Record<Tone, string> = {
  default: 'bg-bg-2 text-text-2 border-line-1',
  violet: 'bg-violet-soft text-violet-deep border-violet/20',
  cyan: 'bg-cyan/10 text-cyan border-cyan/20',
  emerald: 'bg-emerald/10 text-emerald border-emerald/25',
  rose: 'bg-rose/10 text-rose border-rose/25',
  amber: 'bg-amber/10 text-amber border-amber/30',
};

export function Chip({ tone = 'default', children, className }: ChipProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium',
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
